"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Segment {
    constructor({ label, value }) {
        this.toJSON = () => ({
            label: this.label,
            value: this.value,
        });
        this.label = label;
        this.value = value;
    }
}
Segment.fromJSON = (json) => {
    const { label, value } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (typeof value !== 'number')
        throw new Error('.value must be a string');
    return new Segment({
        label,
        value,
    });
};
exports.default = Segment;
